import apiFetch from '../apiFetch'

export default function (token, massiveDownloadId) {
  return apiFetch({ endPoint: `Document/MassiveDownload/${massiveDownloadId}/Cancel/${true}`, method: 'PUT', body: null, token: token })
}
